import {styled} from "@mui/material/styles"

export const Banner = styled("div")`
    display: flex;
    padding: 0.5rem 1rem 0 0;
`

export const BannerInfoIcon = styled("img")`
    position: relative;
    top: calc(50% - 1.2rem);
`

export const BannerIconWrapper = styled("div")`
    max-height: 1.31rem;
    max-width: 2.625rem;
`
